import { parse, stringify } from 'query-string';
import _omit from 'lodash/omit';
import { ERRORS } from "../../constants/index.js";
/**
 * remove errors from url
 * @param {string} search [window.location.search]
 * @returns {string} search query without errors [window.location.search]
 */
export function removeErrorsFromUrl(search) {
  if (search === void 0) {
    search = '';
  }
  var searchQuery;
  try {
    searchQuery = stringify(_omit(parse(decodeURIComponent(search)), ERRORS.ERROR_CODES));
  } catch (e) {
    searchQuery = search;
  }
  return searchQuery;
}